'use client';

import Image from "next/image";

// Components
import useWindowsSize from '@src/hooks/useWindowSize';

import { LOGOS } from "./data";

const CIcon = ({ width, height, className, alt, src, ...props }) => {
  return (
    <div className="flex items-center justify-center h-[80px]">
      <Image
        width={width}
        height={height}
        alt={alt}
        src={src}
        className={`object-contain w-auto h-auto ${className}`}
        {...props}
      />
    </div>
  )
}

const ListMitra = () => {
  const { dd22XL } = useWindowsSize();

  return (
    <div className="bg-[#040704] py-4 px-[48px] flex items-center justify-center">
      <div className="flex items-center justify-center gap-x-[64px] flex-wrap">
        {LOGOS.map((logo, index) => {
          return (
            <CIcon
              key={`list-mitra-${index}`}
              width={dd22XL ? logo.Mwidth : logo.width}
              height={32}
              alt={logo.name}
              src={logo.url}
            />
          )
        })}
      </div>
    </div>
  )
}

export default ListMitra
